import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";

class EnderecosClienteProvider extends AProvider {
    constructor() {
        super("/cadastros/enderecos_clientes");
    }

    async getEnderecos(clienteId: string): Promise<IDataResponse> {
        try {
            const filter = "cliente_id=" + clienteId;
            const includes = "includes=cidade,pais&"

            const request: IDataRequest = {
                url: this.path + "/?" + includes + filter,
            }

            const response: IDataResponse = await api.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }
            
            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereços",
                statusCode: 404
            }
        }
    }

    async postEnderecos(endereco: any): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/cadastros/enderecos_clientes",
                data: endereco,
            }

            const response: IDataResponse = await api.post(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao adicionar o endereço",
                statusCode: 404
            }
        }
    }

    async putEnderecos(endereco: any): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: this.path + "/" + endereco.id,
                data: endereco,
            }

            const response: IDataResponse = await api.put(request);

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao atualzar o endereço",
                statusCode: 404
            }
        }
    }

    async getEnderecoByCep(clienteId: number, cep: string): Promise<IDataResponse> {
        try {
            const filter = "cliente_id=" + clienteId + "&cep=" + cep;
            const includes = "includes=cidade,pais&"

            const request: IDataRequest = {
                url: this.path + "/?" + includes + filter,
            }

            const response: IDataResponse = await api.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }
            
            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereço",
                statusCode: 500
            }
        }
    }

    async getEnderecoBySequencial(clienteId: number, sequencial: number): Promise<IDataResponse> {
        try {
            const filter = "cliente_id=" + clienteId + "&sequencial=" + sequencial;
            const includes = "includes=cidade,pais&"

            const request: IDataRequest = {
                url: this.path + "/?" + includes + filter,
            }

            const response: IDataResponse = await api.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }
            
            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar endereço",
                statusCode: 500
            }
        }
    }

}

export {EnderecosClienteProvider};